import { useQuery } from 'react-query';

import { axios } from 'lib/axios';

const getFrameworkAgreementSettings = async (frameworkAgreementId) => {
  const {
    data: { data: settings },
  } = await axios.get(`/api/framework_agreements/${frameworkAgreementId}/settings`);
  return settings;
};

export const useFrameworkAgreementSettings = (frameworkAgreementId, queryOptions = {}) =>
  useQuery(
    ['framework-agreement-settings', frameworkAgreementId],
    () => getFrameworkAgreementSettings(frameworkAgreementId),
    {
      initialData: [],
      enabled: !!frameworkAgreementId,
      ...queryOptions,
    }
  );
